exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CZhyJSZip0r3ja-sWfvT0{width:0;height:0;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"alert": "CZhyJSZip0r3ja-sWfvT0"
};